import { post } from 'helpers/api';
import { useOneOffSubscription } from 'helpers/action_cable/use_one_off_subscription';

import type { Deal } from 'bundles/apex/deals/types';

export function useBuildDealWithAi(path: string) {
  const { subscribe } = useOneOffSubscription();

  return function buildDeal(formData: FormData): Promise<Deal | null> {
    return new Promise((resolve) => {
      subscribe<{ success: true; deal: Deal } | { success: false }>({
        async connected(requestId) {
          formData.append('request_id', requestId);
          await post(path, formData);
        },
        connectedError() {
          resolve(null);
        },
        received(payload) {
          resolve(payload.success ? payload.deal : null);
        },
      });
    });
  };
}
